import type { LoginUser } from '../types/api'

export const getAuthLandingPath = (user: LoginUser | null | undefined): '/dashboard' | '/organisations' =>
  user?.role.name === 'SUPER_ADMIN' ? '/dashboard' : '/organisations'
